var _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkArrowBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.91504,
    y: 4.00195,
    width: 8.00352,
    height: 1,
    fill: "#2432C8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.73145,
    y: 12.6489,
    width: 11.5356,
    height: 1,
    transform: "rotate(-45 3.73145 12.6489)",
    fill: "#2432C8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 7.99511,
    height: 0.996485,
    transform: "matrix(0 1 1 0 11.9316 4.01123)",
    fill: "#2432C8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkArrowBlue);
export default __webpack_public_path__ + "static/media/link-arrow-blue.3f14ecf72106a1a97651807bc65a8550.svg";
export { ForwardRef as ReactComponent };